import { store } from "@redux"

const hasFullAccess = () => {
  const { userAccountInfo: { accesses } } = store.getState()

   return accesses.hasFullAccess
}

export default hasFullAccess